"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiPostQueryRequestData = instanceOfApiPostQueryRequestData;
exports.ApiPostQueryRequestDataFromJSON = ApiPostQueryRequestDataFromJSON;
exports.ApiPostQueryRequestDataFromJSONTyped = ApiPostQueryRequestDataFromJSONTyped;
exports.ApiPostQueryRequestDataToJSON = ApiPostQueryRequestDataToJSON;
exports.ApiPostQueryRequestDataToJSONTyped = ApiPostQueryRequestDataToJSONTyped;
/**
 * Check if a given object implements the ApiPostQueryRequestData interface.
 */
function instanceOfApiPostQueryRequestData(value) {
    return true;
}
function ApiPostQueryRequestDataFromJSON(json) {
    return ApiPostQueryRequestDataFromJSONTyped(json, false);
}
function ApiPostQueryRequestDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fields': json['fields'] == null ? undefined : json['fields'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'hints': json['hints'] == null ? undefined : json['hints'],
        'skip': json['skip'] == null ? undefined : json['skip'],
    };
}
function ApiPostQueryRequestDataToJSON(json) {
    return ApiPostQueryRequestDataToJSONTyped(json, false);
}
function ApiPostQueryRequestDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fields': value['fields'],
        'limit': value['limit'],
        'hints': value['hints'],
        'skip': value['skip'],
    };
}
